import { Directive, HostBinding, Input, OnInit, Host } from '@angular/core';

@Directive({
  selector: '[sukaGrid]'
})
export class GridDirective {
  @HostBinding('class.grid') baseClass = true;
}

@Directive({
  selector: '[sukaRow]'
})
export class RowDirective {
  @HostBinding('class.row') baseClass = true;
  @HostBinding('class.no-gutters') @Input() noGutters = false;
  @HostBinding('class.row-deck') @Input() rowDeck = false;
}

@Directive({
  selector: '[sukaCol]'
})
export class ColumnDirective implements OnInit {
  @Input() class = '';
  @Input() columnNumbers = {};
  @Input() offsets = {};

  // tslint:disable-next-line: variable-name
  protected _columnClasses: string[] = [];

  @HostBinding('class')
  get columnClasses(): string {
    return this._columnClasses.join(' ');
  }

  set(classes: string) {
    this._columnClasses = classes.split(' ');
  }

  ngOnInit() {
    try {
      const columnKeys = Object.keys(this.columnNumbers);
      if (columnKeys.length <= 0) {
        this._columnClasses.push('col');
      }

      columnKeys.forEach(key => {
        if (this.columnNumbers[key] === 'nobreak') {
          this._columnClasses.push(`col-${key}`);
        } else {
          this._columnClasses.push(`col-${key}-${this.columnNumbers[key]}`);
        }
      });

      Object.keys(this.offsets).forEach(key => {
        this._columnClasses.push(`offset-${key}-${this.offsets[key]}`);
      });
    } catch (err) {
      console.error(`Malformed \`offsets\` or \`columnNumbers\`: ${err}`);
    }

    if (this.class) {
      this._columnClasses.push(this.class);
    }
  }
}
